const addIntervenants = () => {
  const form = document.querySelector('#new_intervenant_mo')
}

export default addIntervenants;
